import { useCallback, useState } from "react";
import { IPaymentResponse } from "../../../models/payment-response.interface";
import axios from "axios";
import { IBreachDetails } from "../../../models/breach-details.interface";

export const useCreditCardPayment = (
  { amount, ticketNbr, vrm, location }: IBreachDetails,
  email: string
) => {
  const [creditCardPaymentLoading, setCreditCardPaymentLoading] =
    useState<boolean>(false);
  const [creditCardPaymentError, setCreditCardPaymentError] = useState<
    string | null
  >(null);

  const payTicketWithCreditCard = useCallback(async () => {
    setCreditCardPaymentLoading(true);
    const response = await axios.post<IPaymentResponse>(
      `${process.env.REACT_APP_API_URL}/payment`,
      {
        amount,
        ticketNbr,
        vrm,
        siteName: location,
        email,
      }
    );
    const { data: paymentResponse } = response;
    if (paymentResponse.error && paymentResponse.message) {
      setCreditCardPaymentError(paymentResponse.message);
      setCreditCardPaymentLoading(false);
    } else {
      window.open(paymentResponse.redirectUrl, "_self", "noopener,noreferrer");
    }
  }, [amount, location, ticketNbr, vrm]);

  return {
    creditCardPaymentError,
    creditCardPaymentLoading,
    payTicketWithCreditCard,
  };
};
